import 'core-js/stable'
import 'react-app-polyfill/ie9'

import * as Sentry from '@sentry/browser'
import PlurallTracker from 'plurall-tracker'
import React from 'react'
import ReactDOM from 'react-dom'
import { App, Error, LoginCallback } from 'views'
import { createBrowserHistory } from 'history'
import { PrivateRoute } from 'components'
import { Route, Router, Switch } from 'react-router-dom'

const {
  REACT_APP_ACCOUNT_URL,
  REACT_APP_NODE_ENV,
  REACT_APP_SENTRY_CLIENT,
} = process.env

const switchEnvs = {
  local: 'development',
  pull_request: 'staging',
}

const environment =
  Object.keys(switchEnvs).includes(REACT_APP_NODE_ENV)
  ? switchEnvs[REACT_APP_NODE_ENV]
  : REACT_APP_NODE_ENV

window.tracker = new PlurallTracker({
  clientId: 'aula-digital',
  environment,
})

const customHistory = createBrowserHistory()
customHistory.listen(() => window.tracker.pageView())

if (REACT_APP_NODE_ENV !== 'local') {
  Sentry.init({
    dsn: REACT_APP_SENTRY_CLIENT,
    environment: REACT_APP_NODE_ENV,
  })
}

ReactDOM.render(
  <Router history={customHistory}>
    <Switch>
      <Route path='/login/callback' component={LoginCallback} />
      <Route path='/error' render={props => <Error {...props} />} />
      <Route
        exact
        path='/'
        render={() => {
          window.location.href = REACT_APP_ACCOUNT_URL
          return null
        }}
      />
      <PrivateRoute path='/' component={App} />
    </Switch>
  </Router>,
  document.getElementById('root'),
)
